// extracted by mini-css-extract-plugin
export default {"loader":"LoadingIndicator_loader__XorTs","load7":"LoadingIndicator_load7__Y+kXR"};